import { type CommandProperties, createCommand } from '@canvas/rovo-content-bridge-api';

/**
 * @see {@link HidePanelCommand}
 */
export type HidePanelCommandProperties = CommandProperties;

/**
 * Command to hide the active panel. This is used to notify the databases app to
 * clear the current panel state.
 */
export const HidePanelCommand = createCommand<HidePanelCommandProperties, void>(
  'hide-panel-command',
);
